<template>
    <div>
        <m-assembly-table
            ref="pageForm"
            :formData='formData'
            :columns="columns"
            :data="tableData"
            :tableButtons="tableButtons"
            :loading="loading"
            :currentPage="settings.currentPage"
            :pageSize="settings.pageSize"
            :total="settings.total"
            :settings="settings"
            :rowClassName="rowClassName"
            @onSubmit='onSubmit'
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
            @onSelectionChange='onSelectionChange'
        >
        </m-assembly-table>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from "@/components/awesome/page/assembly_table/index";
import moment from 'moment';
export default {
    name: "invoiceMonitoring",
    components: {
        mAssemblyTable,
    },
    data () {
        const validator = (rule, value, callback) => {
            const { invoiceNo, ctn, cont } = this.getFormDataVModel(this.formData.items);
            if (!invoiceNo && !ctn && !cont) {
                callback(new Error(this.$t('invoiceMonitoring.t26')));
            }
            callback();
        };
        return {
            formData: {
                row: 3,
                items: [
                    {
                        value: '',
                        field: 'invoiceNo',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('invoiceMonitoring.t1'), // 发票号
                        validators: {
                            // required: {
                            //     required: true,
                            //     message: this.$t('createDeliveryOrderToInformView.t49'),
                            // },
                            range: {
                                validator,
                                trigger: 'change'
                            },
                        },
                    },
                    {
                        value: '',
                        field: 'customerFittingPartCode',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('invoiceMonitoring.t2') // 物料编码
                    },
                    {
                        value: '',
                        field: 'desOrgDesc',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('invoiceMonitoring.t3') // 出口组织
                    },
                    {
                        value: '',
                        field: 'ctn',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('invoiceMonitoring.t4') // 箱号
                    },
                    {
                        value: '',
                        field: 'scpPoNo',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('invoiceMonitoring.t5') // SCP PO号
                    },
                    {
                        value: '',
                        field: 'cont',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('invoiceMonitoring.t6') // 柜号
                    },
                    {
                        value: '',
                        field: 'poNumber',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('invoiceMonitoring.t7') // ERP PO号
                    },
                    {
                        value: '',
                        field: 'isSuccess',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            multiple: false,
                            values: [
                                {
                                    label: this.$t('invoiceMonitoring.t23'),
                                    value: 'N'
                                },
                                {
                                    label: this.$t('invoiceMonitoring.t24'),
                                    value: 'Y'
                                }
                            ],
                        },
                        type: 'select',
                        title: this.$t('invoiceMonitoring.t25') // 异常数据
                    },
                    {
                        value: '',
                        field: 'deliveryStatus',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3,
                        },
                        options: {
                            multiple: false,
                            values: [
                            ],
                        },
                        type: 'select',
                        title: this.$t('送货单状态'), // 送货单状态
                    },
                ]
            },
            columns: {
                columns: [
                    {
                        title: this.$t('invoiceMonitoring.t8'), // 商业发票号
                        key: 'invoiceNo',
                        align: 'center',
                        minWidth: 125
                    },
                    {
                        title: this.$t('invoiceMonitoring.t9'), // 发票物料编码
                        key: 'customerFittingPartCode',
                        align: 'center',
                        minWidth: 110
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t17'), // 物料描述
                        key: 'itemDesc',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('importNoticeCommon.t162'), // 回料编码
                        key: 'convertItemCode',
                        align: 'center',
                        minWidth: 110,
                    },
                    {
                        title: this.$t('invoiceMonitoring.t3'), // 出口组织
                        key: 'desOrgDesc',
                        align: 'center',
                        minWidth: 100,
                        tooltip: true
                    },
                    {
                        title: this.$t('ApplyReceiveMgnView.ENTERPRISE_ID'), // 库存组织
                        key: 'orgCode',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: this.$t('UIDLabelPrint.t27'), // 供应商编码
                        key: 'vendorCode',
                        width: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('invoiceMonitoring.t6'), // 柜号
                        key: 'cont',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: this.$t('invoiceMonitoring.t4'), // 箱号
                        key: 'ctn',
                        align: 'center',
                        minWidth: 120,
                        tooltip: true
                    },
                    {
                        title: this.$t('invoiceMonitoring.t10'), // 创建送货单信息
                        key: 'createDeliveryMsg',
                        minWidth: 200,
                        tooltip: true
                    },
                    {
                        title: this.$t('importNoticeCommon.t155'), // 解决方案
                        key: 'tips',
                        minWidth: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('invoiceMonitoring.t7'), // ERP PO号
                        key: 'poNumber',
                        align: 'center',
                        minWidth: 90
                    },
                    {
                        title: this.$t('invoiceMonitoring.t11'), // ERP PO行号
                        key: 'lineNum',
                        align: 'center',
                        minWidth: 100,
                        tooltip: true
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t48'), // 进口通知书号
                        key: 'imptNumber',
                        align: 'center',
                        minWidth: 110
                    },
                    {
                        title: this.$t('invoiceMonitoring.t12'), // 进口通知书状态
                        key: 'imptStatusName',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('importNoticeCommon.t11'), // 报关单号
                        key: 'customsNumber',
                        align: 'center',
                        minWidth: 110
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t2'), // 送货单条码号
                        key: 'barcodeNumber',
                        align: 'center',
                        minWidth: 90
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t13'), // 送货单状态
                        key: 'deliveryStatusName',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('invoiceMonitoring.t13'), // 采购订单数量
                        key: 'quantity',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('invoiceMonitoring.t14'), // 采购剩余可创建数量
                        key: 'residueQty',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('invoiceMonitoring.t15'), // 本次创建数量(QMS发票)
                        key: 'singQty',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('invoiceMonitoring.t16'), // 发票日期
                        key: 'invoiceDate',
                        align: 'center',
                        minWidth: 80,
                        render: (h, params) => {
                            return h('span', params.row.invoiceDate.replace('00:00:00', ''));
                        }
                    },
                    {
                        title: this.$t('invoiceMonitoring.t17'), // 币别
                        key: 'currency',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('invoiceMonitoring.t18'), // 发票SCP PO号
                        key: 'scpPoNo',
                        align: 'center',
                        minWidth: 120
                    },
                    {
                        title: this.$t('invoiceMonitoring.t19'), // 发票总净重
                        key: 'nw',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('invoiceMonitoring.t20'), // 发票单个物料净重
                        key: 'singNw',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('importNoticeCommon.t163'), // 毛重
                        key: 'grossWeight',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('importNoticeCommon.t164'), // 地板台
                        key: 'platform',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('invoiceMonitoring.t21'), // 发票原始箱号
                        key: 'orignCtn',
                        align: 'center',
                        minWidth: 120,
                        tooltip: true
                    },
                    {
                        title: this.$t('invoiceMonitoring.t22'), // 发票总数
                        key: 'itemQty',
                        align: 'center',
                        minWidth: 80
                    },
                    {
                        title: this.$t('importNoticeCommon.t140'), // PO状态
                        key: 'closedCode',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('importNoticeCommon.t153'), // OMS超发回写状态
                        key: 'peripheralStatus',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('importNoticeCommon.t154'), // OMS超发回写消息
                        key: 'peripheralMessage',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('importNoticeCommon.t165'), // PO项目号
                        key: 'poProjectNum',
                        minWidth: 100,
                        tooltip: true,
                    },
                    {
                        title: this.$t('importNoticeCommon.t166'), // OMS项目号
                        key: 'omsProjectNum',
                        minWidth: 100,
                        tooltip: true,
                    },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons:  [
                    {
                        label: '导出',
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                this.$set(button, 'loading', true);
                                this.exportExcel(button);
                            }
                        }
                    }
                ]
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
        }
    },
    methods: {
        onSubmit (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSelectionChange (selection) {
            this.selection = selection;
        },
        onSearch () {
            this.loading = true;
            let postData = this.getFormDataVModel(this.formData.items);
            axios.post('/gscint/imptNotyHeader/queryInvoiceNoCreateDeliveryInfo', {
                ...postData,
                pageIndex: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                language: this.$i18n.locale,
            })
            .then((res) => {
                this.loading = false;
                let data = res.data.data;
                if (data.code === '1') {
                    this.tableData = data.datas.list;
                    this.settings.total = data.datas.total;
                } else {
                    this.showErrorTips('loading', data.msg);
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        exportExcel (button) {
            axios.get('/gscint/imptNotyHeader/exportInvoiceNoCreateDeliveryInfo', {
                    params: {
                        paraJson: JSON.stringify({
                            ...this.getFormDataVModel(this.formData.items)
                        })
                    },
                    responseType: 'blob'
            })
            .then((res) => {
                this.$set(button, 'loading', false);
                this.downloadFile(res.data, `${this.$t('DeliveryOrderQuery.t58')}.xls`);
            })
            .catch(() => {
                this.$set(button, 'loading', false);
                this.showErrorTips();
            });
        },
        rowClassName({ tips }) {
            return tips ? 'm-table-row-highlight m-table-row-highlight-red' : '';
        },
    },
    mounted() {
        this.getDict('INT_deliveryOrderStatus', (data) => {
            this.getFormDataItemObj(this.formData.items, 'deliveryStatus').options.values = data;
        });
    },
}
</script>
<style lang="less" scoped>
/deep/ .m-table-row-highlight-red {
    .m-table-cell {
        color: red;
    }
}
</style>